import React from "react";
import { useState } from "react";
import locationpinchildpost from "src/Assets/images/locationpinchildpost.png";
import "../../styles/postPhotoItemStyle.css";
import closebutton from "src/Assets/images/CloseButton.svg";
import LocationUpdate from "../../Components/DefaultCommunity/locationUpdate";

export default function PostPhotoItem({
  id,
  imageFile,
  path,
  description,
  location,
  removeImageClick,
  onDescriptionChange,
  handleClick,
  onLocationSubmit,
  isLocationSelect,
  setIsLocationSelect,
  setLng,
  setLat,
  isLat,
  isLng,
  setOpen,
  open,
}) {
  const [selectedImage, setSelectedImage] = useState(null);

  React.useEffect(() => {
    if (!imageFile) {
      setSelectedImage(null);
      return;
    }
    let isMounted = true;
    const reader = new FileReader();
    reader.onload = (e) => {
      if (isMounted) {
        setSelectedImage(e.target.result);
      }
    };
    reader.readAsDataURL(imageFile);
    return () => {
      isMounted = false;
    };
  }, [imageFile]);

  const handleRemoveIconClick = () => removeImageClick(id);
  const handleDescriptionChange = (e) => onDescriptionChange(e, id);

  return (
    <div className="postPhotoItemStyle mb-3">
      <div className="closerImage">
        <img src={selectedImage} alt="selected" className="image" />
        <div
          className=" closeIcon close-icon mt-2 mr-2"
          onClick={handleRemoveIconClick}
        >
          <img src={closebutton} alt="cross-icon" />
        </div>
      </div>

      <textarea
        value={description}
        maxLength={200}
        onChange={handleDescriptionChange}
        placeholder="Add a description..."
      />
      <div className="bottom">
        <div className="location">
          <img
            src={locationpinchildpost}
            alt="icon"
            className="locationIcon"
            style={{height: "20px"}}
            onClick={handleClick}
          />
          <p>{location}</p>
        </div>

        <p>{description.length}/200</p>
      </div>

      <LocationUpdate
        open={open}
        setOpen={setOpen}
        isLocationSelect={setIsLocationSelect}
        setLng={setLng}
        setLat={setLat}
        isLat={isLat}
        isLng={isLng}
        onLocationSubmit={() => onLocationSubmit(id)}
      />
    </div>
  );
}
